import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { createSlice } from '@reduxjs/toolkit'
import { API_BASE_URL } from '../../config'
import { getToken } from '../authentication/apiAuthentication'

export const apiDashboardSlice = createApi({
  reducerPath: 'apiDashboard',
  baseQuery: fetchBaseQuery({ 
    baseUrl: `${API_BASE_URL}`,
    prepareHeaders: async (headers, { getState }) => {
      // getState for context
      const msalContextProgress = getState().apiAuth.inProgress

      let token = await getToken(msalContextProgress)
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }

      return headers
    },
  }),
  endpoints: builder => ({
    getCloudSystemSummaries: builder.query({
      query: ({type}) => `/v1/cloudsystems?type=${type}`,
      transformResponse: (response) => {
        if (response) {
          response.sort((a, b) => {
            if (a.serialNumber < b.serialNumber) return -1
            else if (a.serialNumber > b.serialNumber) return 1
            else return 0
          })
        }

        return response
      },
      async onQueryStarted(id, {dispatch, queryFulfilled}) {
        // Ensure that the uncommissioned count is properly updated
        if (id?.type == "uncommissioned") {
          try {
            const { data } = await queryFulfilled
            if (data) {
              dispatch(uncommissionedSummariesSlice.actions.setCount(data?.length ?? 0))
            } else if (data === null) { // Backend will return null in lieu of empty array
              // There are no matching summaries, so zero
              dispatch(uncommissionedSummariesSlice.actions.setCount(0))
            }
          } catch {}
        }
      }
    }),
    getKPIData: builder.query({
      query: ({type}) => ({url: `/v1/kpis?type=${type}`}),
    }),
    postBatchSoftwareUpdateCmd: builder.query({
      query: (serialNumbers) => ({ url: `/v1/cloudsystem/batch-update-software`, method: 'POST', body: serialNumbers }),
    }),
    postBatchContentUpdateCmd: builder.query({
      query: (serialNumbers) => ({ url: `/v1/cloudsystem/batch-update-content`, method: 'POST', body: serialNumbers }),
    }),
  })
})

const initialState = { uncommissionedSummaryCount: 0 }

export const uncommissionedSummariesSlice = createSlice({
  name: "uncommissionedSummariesSlice",
  initialState,
  reducers: {
      setCount(state, count) {
        return {"uncommissionedSummaryCount": Math.max(count.payload, 0)}
      },
      increment(state) {
        return {"uncommissionedSummaryCount": state.uncommissionedSummaryCount + 1}
      },
      decrement(state) {
        return {"uncommissionedSummaryCount": Math.max(state.uncommissionedSummaryCount - 1, 0)}
      }
  },
})

export const {
  useGetCloudSystemSummariesQuery,
  useGetKPIDataQuery,
  usePostBatchSoftwareUpdateCmdQuery,
  usePostBatchContentUpdateCmdQuery,
} = apiDashboardSlice